import { useEffect, useRef, useState } from "react";

const useDebounce = (initialValue, debounceTime = 1000) => {
  const [value, setValue] = useState(initialValue);
  const timerRef = useRef();

  const setDebounceValue = (debounceValue) => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setValue(debounceValue);
    }, debounceTime);
  };

  useEffect(() => {
    return () => {
      clearTimeout(timerRef.current);
    };
  }, []);

  return [value, setDebounceValue];
};

export default useDebounce;
